import { render } from "./CommentChongya.vue?vue&type=template&id=66cebc6e"
import script from "./CommentChongya.vue?vue&type=script&lang=js"
export * from "./CommentChongya.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__